import React from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { SubTabPanelsProps } from '../types';
import MobilePanelButton from './MobilePanelButton';
import {
  MobileGrid,
  MobileGridItem,
  MobilePanelSectionContainer,
  PanelRichText,
} from './styles';

const MobileTabPanels: React.FC<SubTabPanelsProps> = ({
  tabPanels,
  onClick,
  currentTabIndex,
  setCurrentTabIndex,
  ...props
}) => {
  const panelSelectorSections = tabPanels.map((tabContent, index) => {
    const isSelected = index === currentTabIndex;
    return (
      <MobileGrid key={index}>
        <MobilePanelButton
          index={index}
          isSelected={isSelected}
          label={tabContent.label}
          setCurrentTabIndex={setCurrentTabIndex}
        />
        <MobileGridItem
          isSelected={isSelected}
          tabletPortrait={8}
          data-testid={`Mobile-panel-content-${index}`}>
          <PanelRichText html={tabContent.panelContent} />
        </MobileGridItem>
      </MobileGrid>
    );
  });

  return (
    <MobilePanelSectionContainer
      tabletPortrait={8}
      data-testid={'Mobile-panels'}
      {...componentProps(props)}>
      {panelSelectorSections}
    </MobilePanelSectionContainer>
  );
};

export default applyComponentTheme(MobileTabPanels, 'MobileTabPanels');
